/**
 * @see https://www.gatsbyjs.com/docs/how-to/images-and-media/working-with-gifs/#accessibility-concerns-with-animated-gifs
 * @see https://www.gatsbyjs.com/docs/using-client-side-only-packages/#workaround-4-load-client-side-dependent-components-with-loadable-components
 */

import Loadable from '@loadable/component';
import type { FunctionComponent } from 'react';
import type { GifProps } from './Gif';

export default Loadable(() => import('./Gif')) as FunctionComponent<GifProps>;
